module.exports = __webpack_public_path__ + "static/linkedinEvent-362eee76556d7e866b6723885ea48792.jpeg";